import {TFunction} from 'i18next';

export enum BookingStatus {
    ApproveClient = 1,
    WaitingForClient,
    ClientArrived,
    ClientNotArrived,
    BookingCanceled,
    Completed1,
    Completed2,
}

const bookingStatusDetails = {
    [BookingStatus.ApproveClient]: { name: "Approve client", color: "#FFD600" },
    [BookingStatus.WaitingForClient]: { name: "Waiting for client", color: "#EA89C2" },
    [BookingStatus.ClientArrived]: { name: "Client arrived", color: "#73D2FB" },
    [BookingStatus.ClientNotArrived]: { name: "Client has not arrived", color: "#5842BE" },
    [BookingStatus.BookingCanceled]: { name: "Booking was canceled", color: "#DC3545" },
    [BookingStatus.Completed1]: { name: "Completed", color: "#1AB394" },
    [BookingStatus.Completed2]: { name: "Completed", color: "#1AB394" },
};

class BookingStatusService {
    getStatusDetails(
      currentStatus: BookingStatus,
      previousStatus: BookingStatus | null,
      isCreate: boolean,
      t: TFunction,
    ) {
        if (!currentStatus) return "";
        const currentStatusDetail = bookingStatusDetails[currentStatus];
        const currentStatusName = t(currentStatusDetail.name);
        const currentStatusColor = currentStatusDetail.color;

        if (isCreate) {
            return `<span style="color: ${currentStatusColor}">${currentStatusName}</span>`;
        }

        if (!previousStatus) {
            return `<span style="color: ${currentStatusColor}">${currentStatusName}</span>`;
        }

        const previousStatusDetail = bookingStatusDetails[previousStatus];
        const previousStatusName = t(previousStatusDetail.name);
        const previousStatusColor = previousStatusDetail.color;

        if (previousStatus === currentStatus) {
            return `<span style="color: ${currentStatusColor}">${currentStatusName}</span>`;
        }

        return `
            <span style="color: ${previousStatusColor}">${previousStatusName}</span>
            <i class="bi bi-arrow-right px-1"></i>
            <span style="color: ${currentStatusColor}">${currentStatusName}</span>
        `;
    }
}

const bookingStatusService = new BookingStatusService();
export default bookingStatusService;
